<template>
  <div class="website-404">
    <div class="container">
      <div class="content">
        <div class="error-code">404</div>
        <h1 class="title">页面未找到</h1>
        <p class="subtitle">抱歉，您访问的页面不存在或已被移除</p>
        <div class="actions">
          <button class="btn-primary" @click="goHome">返回首页</button>
          <button class="btn-secondary" @click="goBack">返回上页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

const goHome = () => {
  router.push('/')
}

const goBack = () => {
  router.go(-1)
}
</script>

<style scoped>
.website-404 {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  padding: 20px;
}

.container {
  max-width: 800px;
  width: 100%;
  text-align: center;
}

.content {
  background: white;
  border-radius: 20px;
  padding: 60px 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.error-code {
  font-size: 120px;
  font-weight: 800;
  color: #2196F3;
  line-height: 1;
  margin-bottom: 20px;
  text-shadow: 4px 4px 0 rgba(33, 150, 243, 0.1);
}

.title {
  font-size: 36px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
}

.subtitle {
  font-size: 18px;
  color: #7f8c8d;
  margin-bottom: 40px;
  line-height: 1.6;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary {
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Segoe UI', sans-serif;
  letter-spacing: 0.3px;
}

.btn-primary {
  background-color: #2196F3;
  color: white;
  box-shadow: 0 4px 16px rgba(33, 150, 243, 0.3);
}

.btn-primary:hover {
  background-color: #0d47a1;
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(33, 150, 243, 0.4);
}

.btn-secondary {
  background-color: #f1f2f6;
  color: #2c3e50;
}

.btn-secondary:hover {
  background-color: #dfe4ea;
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .content {
    padding: 40px 20px;
  }

  .error-code {
    font-size: 80px;
  }

  .title {
    font-size: 28px;
  }

  .subtitle {
    font-size: 16px;
  }

  .actions {
    gap: 15px;
  }

  .btn-primary,
  .btn-secondary {
    padding: 12px 24px;
    font-size: 15px;
  }
}
</style>